export default __webpack_public_path__ + "static/media/cfirst-logo-4mar26-2.40a2bcde.png";